export default "__VITE_ASSET__Cdsycd4X__"